import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import { Output, EventEmitter } from '@angular/core';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {SnackService} from '../../services/snack.service';
import {DialogService} from '../../services/dialog.service';
import {Router} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {Filter} from '../../model/Helpers/Filter';
import {Pagination} from '../../model/Helpers/Pagination';
import {UserDeleteConfirmDialogComponent} from '../../UsersModule/UserDeleteConfirmDialogComponent/user-delete-confirm.dialog.component';
import {User} from '../../model/Entities/User';
import { DocumentsDataSource } from '../../model/DataSources/DocumentsDataSource';
import {DocumentService} from '../../services/document.service';
import {DocumentTypeService} from '../../services/document-type.service';
import {DocumentType} from '../../model/Entities/DocumentType';
import {ContractState} from '../../model/Entities/ContractState';
import {UserRole} from '../../model/Entities/UserRole';
import {DocumentCreateDialogComponent} from '../DocumentCreateDialogComponent/document-create.dialog.component';
import {
    ContractItemsTransferDialogComponent
} from '../../ContractsModule/ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {DocumentDeleteDialogComponent} from '../DocumentDeleteDialogComponent/document-delete.dialog.component';
import {DocumentCompanyService} from '../../services/document-company.service';
import {DocumentCompany} from '../../model/Entities/DocumentCompany';
import {DocumentPaymentsUploadDialogComponent} from '../DocumentPaymentsUploadDialogComponent/document-payments-upload.dialog.component';
import {DocumentExportDialogComponent} from '../DocumentExportDialogComponent/document-export.dialog.component';
import {UserService} from '../../services/user.service';
import {PaymentTypeService} from '../../services/payment-type.service';
import {PaymentTypeEntity} from '../../model/Entities/PaymentType';


@Component({
    selector: 'document-list',
    templateUrl: './document-list.component.html',
    styleUrls: ['./document-list.component.scss']
})

export class DocumentListComponent extends BaseListComponent implements AfterViewInit {
    tableColumns: String[] = ['full_number', 'client', 'issue_date', 'tax_date', 'due_date', 'variable_symbol', 'price', 'actions'];


    @Input() link = false;
    @Input() customer = false;
    @Input() contract = null;
    @Input() simple = false;
    @Input() documentLink = null;
    @Output() documentSelected = new EventEmitter<any>();

    defaultFilters = {
        from: null,
        to: null,
        documentType: null,
        contract: null,
        documentCompanyId: null,
        paymentTypeId: null,
        isExported: null,
    };

    filters: any = {
        from: null,
        search: null,
        to: null,
        documentType: null,
        contract: null,
        documentCompanyId: null,
        paymentTypeId: null,
        isExported: null,
    };



    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('search') search: ElementRef;
    documentTypes: DocumentType[];
    documentCompanies: DocumentCompany[];
    paymentTypes: PaymentTypeEntity[];

    constructor(
        private dialogService: DialogService,
        private documentService: DocumentService,
        private documentTypeService: DocumentTypeService,
        private documentCompanyService: DocumentCompanyService,
        private paymentTypeService: PaymentTypeService,
        private userService: UserService,
    ) {
        super();
        this.dataSource = new DocumentsDataSource(this.documentService);
    }

    ngAfterViewInit() {
        this.prepareDataLoading();
        this.reloadPage();
        this.loadDocumentTypes();
        this.loadDocumentCompanies();
        this.loadPaymentTypes();
    }

    createDocument() {
        this.dialogService.showDialog(DocumentCreateDialogComponent, {}).afterClosed().subscribe((r) => { console.log(r); });
    }

    loadDocumentTypes(): void {
        this.documentTypeService.getSimpleList([]).subscribe((data: DocumentType[]) => {
            this.documentTypes = data;
        });
    }

    loadDocumentCompanies(): void {
        this.documentCompanyService.getSimpleList([]).subscribe((data: DocumentCompany[]) => {
            this.documentCompanies = data;
        });
    }

    loadPaymentTypes(): void {
        this.paymentTypeService.getSimpleList([new Filter('visible', '1')]).subscribe((data: PaymentTypeEntity[]) => {
            this.paymentTypes = data;
        });
    }

    linkDocument(document) {
        this.documentSelected.emit(document);
    }

    setPage(page = 1) {
        this.paginator.pageIndex = page - 1;
    }

    prepareDataLoading(): void {
        if (!this.simple) {
            merge(
                this.paginator.page,
                this.sort.sortChange,
                Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged(),
                [],
                this.dataChangedEventSubject
            ).subscribe(() => {
                if (!this.dataSource) {
                    return;
                }


                const params = {
                    expand: 'documentType,customer,totalPaid,totalPrice,pohoda,documentCurrency',
                    summary: '',
                };


                this.dataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.sort.active, this.sort.direction), this.getFilters(), params);
            });
        } else {
            this.dataChangedEventSubject.subscribe(() => {
                if (!this.dataSource) {
                    return;
                }


                const params = {
                    expand: 'documentType,customer,totalPaid,totalPrice,pohoda,documentCurrency',
                    summary: '',
                };

                const pageSize = this.pageSize;
                const pageIndex = this.initialPageIndex;
                const sortActive = 'full_number';
                const sortDirection = 'desc';

                this.dataSource.loadPage(
                    new Pagination(pageSize, pageSize * pageIndex),
                    new SortInfo(sortActive, sortDirection), this.getFilters(), params);
            });
        }
    }

    public getFilters(): Filter[] {
        const f = [];

        console.log(this.contract);

        if (this.contract) {
            f.push(new Filter('contract_id', this.contract));
        }

        if (this.filters.from) {
            f.push(new Filter('from', this.filters.from.toISOString()));
        }

        if (this.customer) {
            f.push(new Filter('customer_id', this.customer));
        }

        if (this.filters.to) {
            f.push(new Filter('to', this.filters.to.toISOString()));
        }

        if (this.link) {
            f.push(new Filter('disabled_linked_to', this.documentLink.id));
        }

        if (this.filters.search) {
            f.push(new Filter('search', this.filters.search));
        }

        if (this.filters.documentType) {
            f.push(new Filter('document_type', this.filters.documentType));
        }

        if (this.filters.documentCompanyId) {
            f.push(new Filter('document_company_id', this.filters.documentCompanyId));
        }

        if (this.filters.paymentTypeId) {
            f.push(new Filter('payment_type_id', this.filters.paymentTypeId));
        }

        if (this.filters.isExported !== null && this.filters.isExported !== undefined) {
            f.push(new Filter('is_exported', this.filters.isExported));
        }

        return f;
    }


    delete(document) {
        this.dialogService.showDialog(DocumentDeleteDialogComponent, {
            'document': document,
        }).afterClosed().subscribe((result: any) => {
            if (result) {
                this.reloadPage();
            }
        });

    }

    uploadPayments() {
        this.dialogService.showDialog(DocumentPaymentsUploadDialogComponent, {}).afterClosed().subscribe((result: any) => {
            if (result) {
                this.reloadPage();
            }
        });
    }

    exportDocuments() {
        const filterData: any = {};
        if (this.filters.documentCompanyId) {
            filterData.documentCompanyId = this.filters.documentCompanyId;
        }
        if (this.filters.from) {
            filterData.from = this.filters.from;
        }
        if (this.filters.to) {
            filterData.to = this.filters.to;
        }
        this.dialogService.showDialog(DocumentExportDialogComponent, filterData, 600, 500).afterClosed().subscribe((result: any) => {
            if (result) {
                this.reloadPage();
            }
        });
    }

    canEditDocuments(): boolean {
        return this.userService.isAccountant();
    }
}




// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentListComponent/document-list.component.ts